'use client';

import { useEffect } from 'react';
import { reportFrontendError } from '@/lib/frontend-error-reporter';
import { isChunkLoadError, reloadOnceForChunkError } from '@/lib/chunk-error';

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const chunkFailure = isChunkLoadError(error);

  useEffect(() => {
    reportFrontendError(error, { source: 'react-boundary', digest: error.digest });
    // 배포가 있었다면 이 탭이 들고 있는 청크는 서버에 없다. 리렌더로는 풀리지 않으므로
    // 문서를 새로 받아온다. 이미 한 번 썼거나 sessionStorage 를 못 쓰면 아래 화면이 남는다.
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h2 className="text-xl font-semibold">페이지를 불러오지 못했습니다.</h2>
      {/* 청크가 사라진 경우 reset() 은 의미가 없다 — 다시 렌더해도 파일은 여전히 없다.
          여기까지 왔다는 건 자동 새로고침이 이미 한 번 쓰였다는 뜻이라, 선택은 사용자에게 넘긴다. */}
      {chunkFailure ? (
        <button type="button" className="rounded bg-black px-5 py-2 text-white" onClick={() => window.location.reload()}>
          새로고침
        </button>
      ) : (
        <button type="button" className="rounded bg-black px-5 py-2 text-white" onClick={reset}>
          다시 시도
        </button>
      )}
    </div>
  );
}
